export const COMPANY_CONFIG_RULES = {
  maxImageSize: parseInt(
    process.env.REACT_APP_COMPANY_MAX_AVATAR_SIZE ||
    process.env.REACT_APP_DEFAULT_MAX_AVATAR_SIZE ||
    "1"
  ),
};